"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const compareConsentStringsAndRemoveConsent = () => {
    const today = new Date();
    const oneMonthDateString = new Date(new Date().setDate(today.getDate() - 30));
    (today < oneMonthDateString) ? localStorage.removeItem("GS1_YT_VIDEO_CONSENT") : '';
};
compareConsentStringsAndRemoveConsent();
exports.default = {};
